import './styles/tabForSidebar.scss';
import data from './data';
import config from './config';
import removeFromWishlistAction from './actions/removeFromWishlist.action';
import { wishTriggers } from './main';
import { splitProductTitle } from '../js/helpers/splitProductTitle';
import { getLazyLinkToImage } from '../js/helpers/getLazyLinkToImage';
import { dlWishlistRemoveEvent } from '../events/wishlist/dl.wishlist.remove.event';
const vNode = window.vNode;
let tabHead;
let tabBody;
const renderHead = () => {
    let oldHead;
    return () => {
        const newHead = vNode.create('p', { class: 'ss__head_item_title' }, [
            vNode.create('s-svg', { 'data-icon': '#icon__header_heart' }),
            vNode.create('b', {}, ['WISHLIST']),
            vNode.create('span', {}, [`(${data.itemCount})`])
        ]);
        vNode.patch(oldHead, newHead, tabHead);
        oldHead = newHead;
    };
};
const createRegisterMessage = () => {
    return vNode.create('div', { class: 'ss__wishlist_registration text:center' }, [
        vNode.create('p', { class: 'ss__wishlist_registration_title' }, [
            'SAVE YOUR WISHLIST',
            vNode.create('br'),
            'ACCESS FROM ANY DEVICE'
        ]),
        vNode.create('a', { href: '/account/register?f=wish', class: 'ss__wishlist_registration_button btn:accent-gradient' }, ['CREATE ACCOUNT']),
        vNode.create('span', { class: 'ss__wishlist_registration_login' }, [
            'Already have an account? ',
            vNode.create('a', { href: '/account/login', rel: 'nofollow' }, ['Login'])
        ])
    ]);
};
const createItemVNodes = (items) => {
    const sizes = window.innerWidth > 767 ? '110px' : `${Math.round(window.innerWidth * 0.224)}px`;
    return vNode.create('div', { class: 'ss__wishlist_items-wrapper' }, [
        vNode.create('ul', { class: 'ss__wishlist_items' }, items.map((item) => {
            const lazySrc = getLazyLinkToImage(item.image);
            return vNode.create('li', { key: item.id, class: 'ss__wishlist_item' }, [
                vNode.create('a', { href: item.url, class: 'ss__wishlist_item_heading' }, [
                    vNode.create('div', { class: 'ss__wishlist_item_image' }, [
                        vNode.create('div', { class: 'image-wrapper' }, [
                            vNode.create('img', {
                                style: 'background-color: #f2f3f4',
                                src: item.image,
                                srcset: [110, 180, 360, 540].map(width => `${lazySrc.replace('{width}', width.toString())} ${width}w`).join(', '),
                                loading: 'lazy',
                                height: 110,
                                width: 110,
                                sizes,
                                alt: item.title
                            })
                        ])
                    ]),
                    vNode.create('p', { class: 'ss__wishlist_item_title' }, (function () {
                        const { title, subtitle } = splitProductTitle(item.title);
                        return [
                            vNode.create('b', {}, [title]),
                            vNode.create('span', {}, [subtitle])
                        ];
                    }()))
                ]),
                vNode.create('button', {
                    class: 'ss__wishlist_item_remove btn:cleared',
                    title: 'Remove from list',
                    events: {
                        click: () => {
                            removeFromWishlistAction(item.sku);
                            dlWishlistRemoveEvent(item);
                        }
                    }
                }, [
                    vNode.create('s-svg', { 'data-icon': '#icon--close-x', style: 'aspect-ratio: 17.4 / 17.4;' })
                ])
            ]);
        }))
    ]);
};
const renderBody = () => {
    let oldItems = [];
    return () => {
        const newItems = [];
        const itemsForRender = data.products.filter((item) => !item.deletedFromMeta).reverse();
        if (itemsForRender.length > 0) {
            if (!window.customer.id) {
                newItems.push(createRegisterMessage());
            }
            newItems.push(createItemVNodes(itemsForRender));
        }
        else {
            newItems.push(vNode.create('p', { class: 'ss__wishlist_empty-message' }, ['Your wishlist is empty']));
        }
        vNode.patch(oldItems, newItems, tabBody);
        oldItems = newItems;
    };
};
const init = (openFunc) => {
    tabHead = document.createElement('button');
    tabBody = document.createElement('div');
    tabHead.dataset.tabKey = tabBody.dataset.tabKey = 'ss_wishlist';
    tabHead.setAttribute('aria-label', 'Wishlist tab');
    tabHead.classList.add('btn:cleared');
    const head = renderHead();
    const body = renderBody();
    head();
    body();
    const subscribe = () => {
        wishTriggers.on('listUpdated', () => {
            head();
            body();
        });
    };
    if (wishTriggers !== undefined) {
        subscribe();
    }
    else {
        document.addEventListener('wishlistLoaded', subscribe);
    }
    document.body.addEventListener('click', (event) => {
        if (!event.target)
            return;
        const target = event.target;
        const open = target.closest(config.selector.wishlistOpen);
        if (open) {
            openFunc('ss_wishlist');
        }
    });
    return {
        head: tabHead,
        body: tabBody,
        tabName: 'wishlist',
        key: 'ss_wishlist'
    };
};
export const wishlistTabForSidebar = init;
